import React, { useState } from "react";
import { TiArrowDownThick } from "react-icons/ti";
import { Question } from "../../types/Question";
import { TrailBlock } from "./TrailBlock";
import womanTrail from "./undraw_adventure_map_hnin-1.svg";

export const Trail = ({ feedbeek }: Props) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <>
            <div
                className="flex items-center bg-white border-l-4 border-green-600
                hover:bg-gray-300 justify-between shadow-md 
                border p-2 cursor-pointer rounded-md mb-4"
                onClick={() => setOpen((prev) => (prev ? false : true))}
            >
                <div className=" font-bold text-2xl italic">
                    Trilha de desenvolvimento
                </div>
                <div>
                    <TiArrowDownThick
                        className={`${
                            open && "transform rotate-180 "
                        } text-2xl text-green-600 `}
                    />
                </div>
            </div>
            <div className="grid grid-cols-1 gap-6 mb-3">
                <div
                    className={`grid grid-cols-2 w-full items-center ${
                        open ? "h-max-92 opacity-1" : "h-max-0 h-0 opacity-0"
                    } 
                transition-all delay-500 duration-300 overflow-hidden`}
                >
                    <div>
                        Vocês estão arrasando, mas nada é tão bom que não possa
                        melhorar! Separamos alguns materiais para te ajudar a
                        continuar evoluindo. Clique nos links abaixo para
                        acessar sua trilha de desenvolvimento.
                    </div>
                    <div className="flex justify-end">
                        <img src={womanTrail} alt="trai" />
                    </div>
                </div>
                {feedbeek.map((item) => (
                    <div key={item.id}
                        className={`${
                            open
                                ? "h-max-92 opacity-1"
                                : "h-max-0 h-0 opacity-0"
                        } 
                transition-all delay-500 duration-300 overflow-hidden`}
                    >
                        {item.answer?.map((a) => (
                            <div key={item.id}>
                                {a.need_trail && (
                                    <TrailBlock trail={a.need_trail} />
                                )}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </>
    );
};

interface Props {
    feedbeek: Question[];
}
